import { BaseFieldConfig } from "../../../../CommonElements/DynamicFieldRenderer";

export const conveyanceFormFields: BaseFieldConfig[] = [
  {
    name: "date",
    label: "Date",
    type: "date",
    col: 3,
  },
  {
    name: "reason",
    label: "Reason",
    type: "text",
    col: 3,
  },
  {
    name: "source",
    label: "Travel From",
    type: "text",
    col: 3,
  },
  {
    name: "destination",
    label: "Travel To",
    type: "text",
    col: 3,
  },
  {
    name: "mode",
    label: "Mode",
    type: "select",
    col: 3,
    options: [
      { value: "", label: "Select Mode" },
      { value: "car", label: "Car" },
      { value: "bike", label: "Bike" },
      { value: "cab", label: "Cab" },
      { value: "rikshaw", label: "Rikshaw" },
      { value: "bus", label: "Bus" },
      { value: "metro", label: "Metro" },
      { value: "auto", label: "Auto" },
      { value: "others", label: "Others" },
    ],
  },
  {
    name: "distance",
    label: "Distance (in km)",
    type: "number",
    col: 3,
  },
  {
    name: "amount",
    label: "Amount",
    type: "number",
    col: 3,
    disabled: true,
  },
  {
    name: "bill",
    label: "Upload Bill",
    type: "file",
    col: 3,
    accept: "image/*,application/pdf",
  },
];
